import { Actions } from '@components/shared/Actions'
import { EyeIcon } from '@assets/svgs/EyeIcon'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { WeeklyBreakdownItemProps } from '../context/types'

interface ParseOtherServicesProps {
  data: WeeklyBreakdownItemProps[]
  onViewMore: (item: WeeklyBreakdownItemProps) => void
}

export const parseWeeklyBreakdownGrid = ({ data, onViewMore }: ParseOtherServicesProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => {
    const baseColumns: ColumnDefProps[] = [
      {
        id: 'code',
        columnName: '',
        value: item.supplier?.code
      },
      {
        id: 'supplier',
        columnName: 'Fornecedor',
        value: item.supplier?.name,
        minWidth: '16rem',
        maxWidth: '20rem',
        sortable: true,
        stickyPosition: 'left'
      },
      {
        id: 'origin',
        columnName: 'Origem',
        value: item.origin || '-',
        align: 'center',
        sortable: true,
        stickyPosition: 'left'
      },
      {
        id: 'itemClassification',
        columnName: 'Classificação',
        value: item.itemClassification || '-',
        align: 'center',
        minWidth: '10rem',
        sortable: true
      },
      {
        id: 'operation',
        columnName: 'Operação',
        value: `${item.operation?.code} - ${item.operation?.name}` || '-',
        align: 'center',
        minWidth: '16rem',
        sortable: true
      },
      {
        id: 'purchaseOrderCount',
        columnName: 'Qtde OCs',
        value: item.purchaseOrderCount || 0,
        align: 'center',
        minWidth: '8rem',
        sortable: true
      },
      {
        id: 'purchaseOrderAmount',
        columnName: 'Total OCs (R$)',
        value: item.purchaseOrderAmount || 0,
        currency: true,
        align: 'center',
        minWidth: '10rem',
        sortable: true
      }
    ]

    const actionColumn: ColumnDefProps = {
      id: 'action',
      columnName: 'Ações',
      align: 'center',
      minWidth: '5rem',
      maxWidth: '5rem',
      stickyPosition: 'right',
      withoutTooltip: true,
      value: <Actions actions={[{ label: 'Ver mais', icon: <EyeIcon />, onClick: () => onViewMore(item) }]} />
    }

    return [...baseColumns, actionColumn]
  })

  return parsedData
}
